import React from 'react';
import { v1 as uuidV1 } from 'uuid';
import PropTypes from 'prop-types';
import colors from '../utils/colors';

const ChartLabels = ({ labels, direction }) => {
  return (
    <div
      className={`chart-labels d-flex ${
        direction === 'vertical' ? 'flex-column' : ''
      }`}
    >
      {labels.map((item, index) => (
        <div key={uuidV1()}>
          <span
            style={{
              backgroundColor: colors[index],
            }}
          />
          {item}
        </div>
      ))}
    </div>
  );
};
ChartLabels.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
};

ChartLabels.defaultProps = {
  direction: 'vertical',
};

export default ChartLabels;
